module.exports = __webpack_public_path__ + "static/media/ogImage.01f05fa7.WebP";